import React from 'react'
import type { ReactNode } from 'react'
import RightCheckQuizIcon from 'shared/icons/right-check-quiz-icon'
import SquareIcon from 'shared/icons/square-icon'
import WrongCheckQuizIcon from 'shared/icons/wrong-check-quiz-icon'
import { cwd } from 'shared/utils/class-name-with-modifiers'
import {
  CourseQuizDataResultAnswerInterface,
  CourseQuizDataResultInterface,
} from 'modules/course/types/course-quiz-interface'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { AnswersListWrapper } from '../answer-list/answer-list-wrapper'
import { AnswersListItem } from '../answer-list/answers-list-item'
import { AnswersText } from '../answer-list/answers-text'

interface AnswersListProps {
  className?: string
  answers: CourseQuizDataResultInterface['q'][0]['a']
}

const getQuizAnswerIcon = (answer: CourseQuizDataResultAnswerInterface): ReactNode => {
  if (answer.s && answer.c) return <RightCheckQuizIcon className="shrink-0" />

  if (answer.s && answer.c !== answer.s) return <WrongCheckQuizIcon className="shrink-0" />

  return <SquareIcon className="shrink-0 [&>path]:stroke-THEME-disabled [&>path]:stroke-[1px]" />
}

export const AnswersList = ({
  className,
  answers,
}: React.PropsWithChildren<AnswersListProps>): ReactNode => {
  return (
    <AnswersListWrapper className={className}>
      {answers.map((answer, index) => (
        <AnswersListItem
          key={index}
          className={`border-solid! ${cwd(
            addPublicCustomClassNamePrefix('course-quiz__result-answer'),
            {
              ['right']: !!(answer.s && answer.c),
              ['wrong']: !!(answer.c !== answer.s),
            },
          )}`}
        >
          <div className="mt-1">{getQuizAnswerIcon(answer)}</div>
          <AnswersText dangerouslySetInnerHTML={{ __html: answer.t }} />
        </AnswersListItem>
      ))}
    </AnswersListWrapper>
  )
}
